import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapComponent {
  @Input() location:any;
  
  public maps: Record<string, string> = {
    "Budapest, HU, 1031": "assets/i/maps/map-hu_bp.png",  
  };

}
